// Type 'rafce' and it will auto-generate:
import React from 'react';
import Button from '../Button';

const ImageWithContent = () => {
  return (
    <div className='image_with_content'>
      <div className='first_section'>
        <div className='container'>
          <div className='row align-items-center mt-3 mb-3 mt-md-5 mb-md-5'>
            <div className="col-lg-5 col-md-5">
              <div className='right_side_content'>
                <h2 className='main_title'><span>Expertise</span> You Can <strong>Trust</strong>, Solutions You Can Count</h2>
                <p>On.Established with a commitment to excellence and integrity,
                  we offer a comprehensive suite of professional services tailored
                  to meet the diverse needs of our clients. </p>
                <p>Our mission is to uphold the highest standards of the profession,
                  ensuring adherence to ethical practices and principles.</p>
                {/* <p>Our dedicated team of seasoned professionals brings a wealth
                    of experience and a broad spectrum of expertise, enabling us
                    to provide insightful and effective solutions. </p> */}
                <p>At <strong>Vanani & Associates</strong>, we strive to exceed expectations, helping
                  businesses unlock their true potential and achieve sustainable  growth.</p>
                <Button to="/about">Read More</Button>
              </div>
            </div>
            <div className="col-lg-7 col-md-7">
              {/* <div className='left_img_wrap'>
                  <img src='/images/trust_img.jpg' alt='Company profile' className='width'></img>
                </div> */}
              <div className='right_side_text'>
                <div className='col_name three_column d-flex align-items-center justify-content-center'>
                  <h2>980+</h2>
                  <p>Financial Audits Conducted Annually</p>
                </div>
                <div className='cnt_img_wrap six_column'>
                  <img src='/images/counter-first.png'></img>
                </div>
                <div className='col_name three_column d-flex align-items-center justify-content-center'>
                  <h2>1984+</h2>
                  <p>Satisfied Clients and Counting</p>
                </div>

                <div className='cnt_img_wrap three_column p-0'>
                  <img src='images/counter-second.jpg'></img>
                </div>
                <div className='cnt_img_wrap six_column d-flex align-items-center justify-content-center text-center center-text-wrap'>
                  <h2>9870+</h2>
                  <p>Hours Saved for Our Clients through Streamlined Processes</p>
                </div>
                <div className='cnt_img_wrap three_column p-0'>
                  <img src='images/counter-third.jpg'></img>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='second_section'>
        <div className='container'>
          <div className='row align-items-center mt-3 mb-3 mt-md-5 mb-md-5 pt-5 pb-2'>
            <div className="col-lg-6 col-md-6">
              <div className='right_side_content'>
                <h2 className='main_title'>Your One-Stop Destination for <strong> Professional Services.</strong></h2>
                <p>At <strong> Vanani & Associates</strong>, we offer a comprehensive range of financial
                  services under one roof, ensuring all your financial and compliance
                  needs are met with ease and efficiency. </p>
                <p>From Incorporation and Accounting to Audit & Assurance, Taxation,
                  Management Consultancy, Outsourcing, Advisory, Tax Litigation,
                  Corporate Compliances, and CFO Services, we provide seamless,
                  integrated solutions.  </p>
                <p>This holistic approach simplifies your operations, enhances consistency,
                  and allows you to focus on growing your business with confidence.</p>
                <Button to="/services">Read More</Button>
              </div>
            </div>
            <div className="col-lg-6 col-md-6">
              <div className='right_img_wrap'>
                <img src='/images/SERVICES_DESIGN.svg' alt='Company profile' className='width'></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ImageWithContent;